import { FC, useMemo } from 'react'
import styles from 'components/features/coaching/advisorPublicPage/StarsRow/StarsRow.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import StarSvg from 'icons/star.svg'
import { cssVar } from 'helpers/styleHelpers'

const STAR_GAP = 4
const STAR_WIDTH = 16

type StarsRowProps = {
  size?: number
  rating: number
}
export const StarsRow: FC<StarsRowProps> = (props) => {
  const { rating, size = STAR_WIDTH } = props

  const width = useMemo(() => {
    const gapsCount = Math.floor(rating)
    return rating * size + gapsCount * STAR_GAP
  }, [rating, size])

  return (
    <div
      className={ styles.starsRow }
      style={ cssVar({
        '--star-size': `${ size }px`,
        '--ratio': `${ width }px`,
      }) }
    >
      <div className={ styles.grayRow }>
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
      </div>
      <div className={ styles.goldRow }>
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
        <SvgIcon className={ styles.star } src={ StarSvg } />
      </div>
    </div>
  )
}
